import { Avatar, Card } from '@reverse-hr/design-system';
import { useTranslation } from 'react-i18next';
import { useStoreState } from 'easy-peasy';
import { jobCompanyNameSelector } from '@model/Job/Job.selectors';

export const AppCardTask = ({ task }) => {
  const { t } = useTranslation();
  const companyName = useStoreState(jobCompanyNameSelector);
  const hasAvatar = !!task.headHunter.avatarUrl;

  return (
    <Card className="c-app-card-task">
      <div className="c-app-card-task__head">
        {hasAvatar && <Avatar size={24} src={task.headHunter.avatarUrl} />}

        <div>
          <p className="c-app-card-task__title">
            {t('common.formatting.fullName', task.headHunter)}
          </p>

          <p className="c-app-card-task__subtitle">
            {t('searching.tasks.card.date', {
              date: new Date(task.completedAt),
            })}
          </p>
        </div>
      </div>

      <p className="c-app-card-task__text">
        {t('searching.tasks.card.taskDescription', {
          companyName,
          context: task.type,
          count: task.count,
        })}
      </p>
    </Card>
  );
};
